<template>
  <div :class="['box about__tiles__box', color]">
    <h2 class="h h--2">
      <slot name="header"></slot>
    </h2>
    <p>
      <slot></slot>
    </p>
  </div>
</template>

<script>
export default {
  name: 'Box',
  props: {
    color: {
      default: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/about/Box.vue